<div>
  <div class="flex flex-1 justify-between sm:hidden">
    <button type="button" (click)="onSelectPage(pagination.current_page - 1)" [class.opacity-75]="pagination.current_page === 1" [disabled]="pagination.current_page === 1" class="relative inline-flex items-center rounded-md border border-gray-200 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50">Previous</button>
    <button type="button" (click)="onSelectPage(pagination.current_page + 1)" [class.opacity-75]="pagination.current_page === pagination.last_page" [disabled]="pagination.current_page === pagination.last_page" class="relative ml-3 inline-flex items-center rounded-md border border-gray-200 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50">Next</button>
  </div>
  <div class="hidden sm:flex sm:flex-1 sm:items-center sm:justify-between">

    <div class="flex justify-start items-center space-x-3">
      <div>
        <p class="text-sm text-gray-500 dark:text-primary-200">
          <span class="font-semibold">{{ pagination.total | number:'1.0-0' }}</span>
          {{ 'results' | translate }}
        </p>
      </div>

      <!-- Per Page Selection -->
      <!--
      <select
        id="perPageSelect"
        [ngModel]="pagination.per_page"
        (ngModelChange)="onPerPageChange($event)"
        class="border border-gray-200 rounded-md px-2 py-[7px] text-sm text-gray-700 dark:text-primary-200 focus:ring-none focus:border-gray-200 focus:ring-transparent"
      >
        <option *ngFor="let option of [10, 20, 50]" [ngValue]="option">
          {{ option }}
        </option>
      </select>
      -->
    </div>

    <div>
      <nav class="isolate inline-flex -space-x-px rounded-md" aria-label="Pagination">

        <button type="button" (click)="onSelectPage(pagination.current_page - 1)" [disabled]="pagination.current_page === 1" [class.opacity-75]="pagination.current_page === 1" class="relative inline-flex items-center rounded-l-md px-2 py-2 text-gray-400 dark:text-primary-200 ring-1 ring-inset ring-gray-200 dark:ring-primary-200 hover:bg-gray-50 hover:dark:bg-transparent focus:z-20 focus:outline-offset-0">
          <span class="sr-only">Previous</span>
          <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
            <path fill-rule="evenodd" d="M12.79 5.23a.75.75 0 01-.02 1.06L8.832 10l3.938 3.71a.75.75 0 11-1.04 1.08l-4.5-4.25a.75.75 0 010-1.08l4.5-4.25a.75.75 0 011.06.02z" clip-rule="evenodd" />
          </svg>
        </button>

        <ng-container *ngFor="let page of pages">
          <button
            *ngIf="page !== '...'; else ellipsis"
            type="button"
            (click)="onSelectPage(page)"
            [class.bg-blue-royal]="page === pagination.current_page"
            [class.hover\:bg-blue-royal]="page === pagination.current_page"
            [class.text-white]="page === pagination.current_page"
            [class.text-gray-900]="page !== pagination.current_page"
            class="relative inline-flex items-center px-4 py-2 text-sm font-semibold ring-1 ring-inset ring-gray-200 dark:ring-primary-200 focus:z-20 focus:outline-offset-0 dark:text-primary-200"
          >
            {{ page }}
          </button>

          <!-- Ellipsis Button Styled Like Other Buttons -->
          <ng-template #ellipsis>
            <button
              class="relative inline-flex items-center px-4 py-2 text-sm font-semibold ring-1 ring-inset ring-gray-200 dark:ring-primary-200 text-gray-400 hover:bg-gray-50 hover:dark:bg-transparent focus:z-20 focus:outline-offset-0"
              disabled
            >
              ...
            </button>
          </ng-template>
        </ng-container>

        <button type="button" (click)="onSelectPage(pagination.current_page + 1)" [disabled]="pagination.current_page === pagination.last_page" [class.opacity-75]="pagination.current_page === pagination.last_page" class="relative inline-flex items-center rounded-r-md px-2 py-2 text-gray-400 dark:text-primary-200 ring-1 ring-inset ring-gray-200 dark:ring-primary-200 hover:bg-gray-50 hover:dark:bg-transparent focus:z-20 focus:outline-offset-0">
          <span class="sr-only">Next</span>
          <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
            <path fill-rule="evenodd" d="M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z" clip-rule="evenodd" />
          </svg>
        </button>

      </nav>
    </div>
  </div>
</div>
